module.exports = __webpack_public_path__ + "static/img/logo-9.ae77be51.png";